export default __webpack_public_path__ + "static/media/me.cbece349.png";